/**
 * The year a "© <year>" line shows (LIFE-SHORTLISTED-001 P10.1): the calendar year of `now` in the
 * runtime's clock (the viewer's in a browser, the server's in a render). It is ONE function so every
 * footer agrees, and so a test can hand it a clock (MOCK-CLOCK-001).
 *
 * Also served as the leaf subpath `@puffin-core/temporal-core/copyright-year`, which requires nothing:
 * every web footer imports it, and the package root would carry the timezone tables into each bundle.
 *
 * @module @puffin-core/temporal-core/copyrightYear
 */

'use strict';

/**
 * @param {Date} [now] - the instant to read; the current time by default
 * @returns {number} the four-digit year
 * @throws {TypeError} when `now` is not a valid Date
 */
function copyrightYear(now = new Date()) {
  if (!(now instanceof Date) || Number.isNaN(now.getTime())) {
    throw new TypeError(
      `copyrightYear: expected a valid Date, got ${now instanceof Date ? 'Invalid Date' : JSON.stringify(now)}`,
    );
  }
  return now.getFullYear();
}

module.exports = { copyrightYear };
